import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { SelectAdapter } from './SelectAdapter';
import { SELECT_ADDRESS_FIELD } from '../addressUtils/addressConstants';

const required = (value) => {
  return value ? undefined : 'Required';
};

const SelectAddressComponent = ({
  type,
  postCodeAddressList,
  onSelectAddressClick,
  formValues,
  saveFormValues
}) => (
  <Content>
    {(content) => (
      <Field
        name={`${type}.${SELECT_ADDRESS_FIELD}`}
        subscription={{ touched: true, error: true, active: true }}
      >
        {({ meta: { touched, error, active } }) => (
          <GenericFieldWrapper
            name={`${type}.${SELECT_ADDRESS_FIELD}`}
            title={`Choose ${type === 'register' ? 'registered' : type} address`}
            validationMessage={touched && !!error && content.selectListError}
          >
            <Field name={`${type}.${SELECT_ADDRESS_FIELD}`} component="select" validate={required}>
              {({ input }) => (
                <SelectAdapter active={active} value={input.value} onChange={(v) => {}}>
                  <GenericSelect
                    id={`${type}.${SELECT_ADDRESS_FIELD}`}
                    selectedId={
                      formValues[type] && formValues[type].selectAddress
                        ? getShortAddressByValue(
                            formValues[type].selectAddress,
                            postCodeAddressList
                          )
                        : null
                    }
                    {...input}
                    items={postCodeAddressList}
                    onChange={(id) => {
                      input.onChange(getShortAddressById(id, postCodeAddressList));
                      saveFormValues(
                        `${type}.${SELECT_ADDRESS_FIELD}`,
                        getShortAddressById(id, postCodeAddressList)
                      );
                      onSelectAddressClick(id, type);
                    }}
                  />
                </SelectAdapter>
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

const getShortAddressById = (address, postCodeAddressList) => {
  return postCodeAddressList.filter((v) => v.id === address)[0].value;
};
const getShortAddressByValue = (address, postCodeAddressList) => {
  return postCodeAddressList.filter((v) => v.value === address)[0].id;
};
export default SelectAddressComponent;
